import { apiGet } from '../../utils';
import { GetAuditRequestsRequest, GetAuditRequestsResponse } from '../fragments';

export const getAuditRequests = (
  request: GetAuditRequestsRequest
): Promise<GetAuditRequestsResponse> =>
  apiGet<GetAuditRequestsResponse, GetAuditRequestsRequest>('auditrequest', request);
